import { select } from '@angular-redux/store';
import { Component, forwardRef, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BillingService, DialogCreationService } from 'sharedFeatures/sharedServices';
import { StartTrialWin } from './start-trial-win.component';
import { takeUntil } from 'rxjs/operators';
import { accountActions } from 'sharedFeatures/store';
import { NewCompanyWin } from 'sharedFeatures/sharedGui/components/new-company-win';
import { isSuccessResponse } from "sharedFeatures/sharedServices/Responses";
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { CommonApp } from 'sharedFeatures/sharedModels';
import { SharedGuiSmallModule } from '../../../../sharedGuiSmall/sharedGuiSmall.module';
import { ScrollComponent } from '../scroll/scrolldiv.component';
import { LoadingSpinnerService } from 'sharedGuiSmall/sharedServices/loadingSpinner.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'start-trial-win-body',
    templateUrl: './start-trial-win-body.component.html',
    styleUrls: ['./start-trial-win-body.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, ScrollComponent, TranslateModule]
})

export class StartTrialWinBodyComponent {
    /*************** main_app store **********************/
    @select(['appData', 'appComponent'])
    readonly appComponent$!: Observable<any>;
    private appComponent: any = null;
    /*****************************************************/

    /*************** account_app store *******************/
    @select(['accountAppData', 'accountAppComponent'])
    readonly accountAppComponent$!: Observable<any>;
    private accountAppComponent: any = null;
    /*****************************************************/

    // Unsubscribe event
    private storeUnsubscribe = new Subject<void>();

    selectedCompanyId: number = 0;

    startTrialText = $localize`START_A_7_DAY`;
    subscriptionAssignedTitleText = $localize`Trial subscription assigned`;
    subscriptionAssignedBodyText = $localize`Trial subscription assigned successfully to organisation`;

    constructor(@Inject(forwardRef(() => StartTrialWin)) public parent: StartTrialWin,
        private billingService: BillingService,
        private dialogCreation: DialogCreationService,
        private loadingSpinnerService: LoadingSpinnerService
    ) {
    }

    ngOnInit() {
        // Subscribe on the redux store
        this.subscribeReduxStore();
        this.selectedCompanyId = this.parent.selectedCompanyId;
    }

    ngOnDestroy() {
        // Unsubscribe from the redux store
        this.storeUnsubscribe.next();
        this.storeUnsubscribe.complete();
    }

    // Subscribe on the redux store
    private subscribeReduxStore(): void {
        this.appComponent$.pipe(
            takeUntil(this.storeUnsubscribe))
            .subscribe((x: any) => this.appComponent = x);

        this.accountAppComponent$.pipe(
            takeUntil(this.storeUnsubscribe))
            .subscribe((x: any) => this.accountAppComponent = x);

    }

    getApp(): CommonApp {
        if (this.appComponent)
            return this.appComponent;
        else if (this.accountAppComponent)
            return this.accountAppComponent;

        throw new Error('Architecture error.');
    }

    onCloseTrial(): void {
        this.parent.close();
    }

    createCompany(): void {
        let newCompanyWin = <NewCompanyWin>this.getApp().createDialog(NewCompanyWin);
        newCompanyWin.setSize(DomSmallUtils.width(document.body), DomSmallUtils.height(document.body));
        newCompanyWin.show(0, 0);
    }

    refreshAppArea(): void {

        accountActions.getAuthData('true')
        this.appComponent.reloadAuthData(() => {

            this.appComponent.menu.reloadAuthData(() => {
                this.appComponent.RefreshPlan().then(() => {

                })
                this.loadingSpinnerService.setLoading(false);
            });

        })
    }

    refreshAccountAppArea(): void {
        this.accountAppComponent.reloadAuthData(true, () => {
            this.accountAppComponent.menu.reloadAuthData();
            this.accountAppComponent.myplans.loadCompanies();

            const popup = this.dialogCreation.createErrorWarning(
                this.subscriptionAssignedTitleText,
                `${this.subscriptionAssignedBodyText} ${localStorage.getItem('selectedCompanyName')}`, () => {
                    popup.close();
                    this.loadingSpinnerService.setLoading(false);
                }, 250, 'OK', 400);

            popup.show();

        });
    }

    startTrial(): void {

        if (!this.accountAppComponent) {
            this.selectedCompanyId = this.appComponent.authData.lastCompanyId;
        }

        this.parent.close();
        this.loadingSpinnerService.setLoading(true);
        this.billingService.StartTrial(this.selectedCompanyId.toString()).then((data) => {
            if (isSuccessResponse(data)) {
                if (this.accountAppComponent)  // BR-8093 TODO refactoring
                    this.refreshAccountAppArea();
                else
                    this.refreshAppArea();
            }
            else {
                this.parent.close();
                const popup = this.dialogCreation.createErrorWarning("Error", data.errorMessage, () => {
                    popup.close();
                });
                popup.show();
                this.loadingSpinnerService.setLoading(false);
            }
        })
            .catch(error => {
                this.dialogCreation.createUnknownExceptionDialog(error).show();
                this.loadingSpinnerService.setLoading(false);
            });
    }
}
